export default "__VITE_ASSET__13ff0f1c__"